define('TescoMobile_Checkout/js/view/monthly-payment/message-content',['uiComponent', 'jquery', 'Magento_Ui/js/modal/modal', 'mage/translate', 'domReady!'], function (Component, $, modal, $t) {
  'use strict';

  const config = window.checkoutConfig.tescomobile.monthly_payment;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/monthly-payment/message-content',
      messageContent: config.message_content,
      popupContent: config.popup_content,
      monthlyTotal: config.monthly_total,
      firstDirectDebitDate: config.first_direct_debit_date
    },
    modalWindow: null,
    setModalElement: function (element) {
      var self = this;
      var options = {
        modalClass: 'monthly-payment-popup-content',
        innerScroll: true,
        'trigger': '[data-trigger=monthlyPaymentPopupMessageTrigger]',
        type: 'slide',
        title: $t('Choose your monthly payment date'),
        buttons: [{
          text: $t('Done'),
          class: 'action-primary action-accept',
          click: function (event) {
            this.closeModal(event, true);
          }
        }]
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      this.setMonthlyPaymentDate(element);
    },
    setMonthlyPaymentDate: function (element) {
      $('.monthly-payment-first-direct-debit-date').html(this.firstDirectDebitDate);
    }
  });
});

